module.exports = __webpack_public_path__ + "static/massage-bd179551cc1e5b3a89b60aa56ba9cc24.jpg";